import { createFileRoute, useNavigate } from "@tanstack/react-router";
import Kostenrechner, { defaultKostenSearch, type KostenSearch } from "@/pages/Kostenrechner";

const TITLE = "Kreditkarten-Kostenrechner 2026 – Jahreskosten im Vergleich";
const DESCRIPTION =
  "Kostenloser Kostenrechner: Jahresgebühr plus Zinskosten aller Kreditkarten im Vergleich — sortiert nach den tatsächlichen Kosten pro Jahr.";
const URL = "https://www.kreditkarten.de/tools/kostenrechner";

const str = (value: unknown) => (typeof value === "string" ? value : "");

export const Route = createFileRoute("/tools/kostenrechner")({
  validateSearch: (search: Record<string, unknown>): KostenSearch => ({
    saldo: str(search.saldo) || defaultKostenSearch.saldo,
  }),
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: KostenRoute,
});

function KostenRoute() {
  const values = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const setValue = (key: keyof KostenSearch, value: string) => {
    navigate({ search: (prev: KostenSearch) => ({ ...prev, [key]: value }), replace: true });
  };

  return <Kostenrechner values={values} onChange={setValue} />;
}
